import { render, staticRenderFns } from "./TranslatorDetailsOutput.vue?vue&type=template&id=e96a0a44&scoped=true"
import script from "./TranslatorDetailsOutput.vue?vue&type=script&lang=js"
export * from "./TranslatorDetailsOutput.vue?vue&type=script&lang=js"
import style0 from "./TranslatorDetailsOutput.vue?vue&type=style&index=0&id=e96a0a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96a0a44",
  null
  
)

export default component.exports